import _ from 'lodash';

const updateEntitiesList = (state, payload) => {
  const mergedData = state.entityTypes.concat(payload);
  const result = _.uniqBy(mergedData, 'name');
  console.log('merged = ' + mergedData.length);
  console.log('result = ' + result.length);
  state.entityTypes = result;
}

export default {
  updateEntitiesList,
};
